const Dam = {
  inputs: [
    {
      id: 'dam_id',
      elementConfig: {
        type: 'select',
        placeholder: 'کد سد',
        options: [
          { value: 'Alavian', gainValue: 1 },
          { value: 'Bukan', gainValue: 2 },
          { value: 'Ajabshir GhaleChai', gainValue: 3 },
          { value: 'Hasanlu', gainValue: 4 },
          { value: 'Mahabad', gainValue: 5 },
          { value: 'Nahand', gainValue: 6 },
          { value: 'Derik Salmas', gainValue: 7 },
          { value: 'Sarough(Gogerdchi)', gainValue: 8 },
          { value: 'Shahrchai', gainValue: 9 },
          { value: 'Zola', gainValue: 10 },
          { value: 'Tajyar Sarab', gainValue: 11 },
          { value: 'KurdKandi', gainValue: 12 },
        ],
      },
      value: '',
      queryParams: true,
      indexValue: -1,
    },
  ],
  url: 'download/dam_detail',
  title: 'سد',
};

const Hydrometric = {
  inputs: [
    {
      id: 'hydrometric_id',
      elementConfig: {
        type: 'select',
        placeholder: 'کد هیدرومتریک',
        options: [
          { gainValue: 16, value: 'Daryan' },
          { gainValue: 15, value: 'Yalghuz Aghaj' },
          { gainValue: 14, value: 'Abajalu sofla' },
          { gainValue: 13, value: 'Pol Ozbak' },
          { gainValue: 12, value: 'Keshtiban' },
          { gainValue: 11, value: 'Babarud' },
          { gainValue: 10, value: 'Pol-e-Bahramlu' },
          { gainValue: 9, value: 'Gerd Yaqub' },
          { gainValue: 8, value: 'Rasoul Abad' },
          { gainValue: 7, value: 'Nezam Abad' },
          { gainValue: 6, value: 'Dash Band' },
          { gainValue: 5, value: 'Pol-e-Bonab' },
          { gainValue: 4, value: 'Shishvan' },
          { gainValue: 3, value: 'Pol Azarshahr' },
          { gainValue: 2, value: 'Khor Khor' },
          { gainValue: 1, value: 'Pol-sinikh' },
        ],
      },
      value: '',
      indexValue: -1,
      queryParams: true,
    },
  ],
  url: 'download/hydrometric_detail',
  title: 'ایستگاه هیدرومتریک',
};

const Synoptic = {
  inputs: [
    {
      id: 'synoptic_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد سینوپتیک',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/synoptic_detail',
  title: 'سینوپتیک',
};

const WeatherStation = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/weather_detail',
  title: 'ایستگاه هواشناسی',
};

const Snow = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/snow_detail',
  title: 'برف',
};

const Temp = {
  inputs: [
    {
      id: 'weather_station_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد ایستگاه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/temp_detail',
  title: 'دما',
};

const LakeLevel = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/lake_level_detail',
  title: 'تراز دریاچه',
};

const LakeEvaporation = {
  inputs: [
    {
      id: 'lake_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/lake_evaporation_detail',
  title: 'تبخیر دریاچه',
};

const Watershed = {
  inputs: [
    {
      id: 'watershed_id',
      elementConfig: {
        type: 'text',
        placeholder: 'کد دریاچه',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/watershed_detail',
  title: 'حوضه آبریز',
};

const Aquifer = {
  inputs: [
    {
      id: 'aquifer_detail',
      elementConfig: {
        type: 'text',
        placeholder: 'کد آبخوان',
      },
      value: '',
      validation: {
        required: true,
        isNumeric: true,
      },
      valid: false,
      touched: false,
      queryParams: true,
    },
  ],
  url: 'download/watershed_detail',
  title: 'حوضه آبریز',
};

export const downloadTypes = {
  Dam: Dam,
  Hydrometric: Hydrometric,
  Synoptic: Synoptic,
  WeatherStation: WeatherStation,
  Snow: Snow,
  Temp: Temp,
  LakeLevel: LakeLevel,
  LakeEvaporation: LakeEvaporation,
  Watershed: Watershed,
  Aquifer: Aquifer,
};

export const downloadTypesTitles = [
  'Dam',
  'Hydrometric',
  'Synoptic',
  'WeatherStation',
  'Snow',
  'Temp',
  'LakeLevel',
  'LakeEvaporation',
  'Watershed',
  'Aquifer',
];
